module.exports = __webpack_public_path__ + "img/img (18).54ac7aa2.jpg";